module.exports = __webpack_public_path__ + "static/media/amusement(23).41d59c7b.PNG";